.dropdownInline {
  min-width: 256px;
  max-width: 500px;
}
